import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { InvestmentGroups, Fund } from './master-associar-fundos.models';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http'
import { HttpUrlEncodingCodec } from '@app/core/services/auth/encoder';

const BASE_PATH = environment.basePath;
@Injectable({
  providedIn: 'root',
})
export class MasterAssociarFundosService {
  constructor(
    private _$http: HttpClient,
    protected encoder: HttpUrlEncodingCodec,
  ) { }

  getInvestmentGroups() {
    return this._$http
      .get<InvestmentGroups[]>(`${BASE_PATH}/bff/investmentGroups`)
      .toPromise();
  }

  getFund(payload: string) {
    let params = new HttpParams({ encoder: this.encoder })

    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })

    return this._$http.post<Fund>(`${BASE_PATH}/bff/fund/view`, payload, { params: params, headers: headers })
      .toPromise();
  }

  setFund(fund: Fund): Observable<any> {
    return this._$http.put<any>(`${BASE_PATH}/bff/fund`, fund);
  }
}
